'use es6';

import { createContext } from 'react';
import PropTypes from 'prop-types';

/**
 * Context for updating the apollo cache for the query used to fetch the sidebar, either
 * by using updateQuery (imperative updates) or fetchMore (paginated updates).
 * For more info see the apollo docs on useQuery:
 * https://www.apollographql.com/docs/react/api/react-hooks/#usequery
 *
 * @param {object} value      the result of useQuery
 */

export const QueryContext = /*#__PURE__*/createContext({
  updateQuery: null,
  fetchMore: null,
  client: null
});
QueryContext.Provider.propTypes = {
  value: PropTypes.shape({
    updateQuery: PropTypes.func.isRequired,
    fetchMore: PropTypes.func.isRequired,
    client: PropTypes.object.isRequired
  }).isRequired
};